import styled from 'styled-components';

export const BankList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px 20px;
  background: #fff;
`;

export const BankListItem = styled.div`
  display: flex;
  flex: 1 1 40%;
  padding: 10px 0;
  align-items: center;
`;

export const SubTitle = styled.div`
  padding-left: 8px;
`;
